export const MANAGE_RULE = 'Manage Rule';
export const SAVE = 'Save';
export const ENABLE_MATCH_RULE = 'Enable Match Rule';
export const RULE_DESCRIPTION =
  'Enabling this rule allows customers to match again only after time limit';
export const ENABLE_NFC_TICKET_OUT = 'Enable NFC Ticket Out';
export const NFC_TICKET_OUT_DESCRIPTION =
  'When enabled, employees with NFC access can scan a machine to auto-fill the Ticket Out form. Turn this off to require manual machine entry.';
export const ENABLE_AUDIT_VERIFICATION =
  'Enable Audit Verification of Bonuses & Raffles';
export const AUDIT_VERIFICATION_DESCRIPTION =
  'When enabled, a reading session cannot be closed until every bonus and raffle in that session has been audited (approved or flagged).';
export const ENABLE_TICKET_PHOTO = 'Enable Ticket Photo Requirement';
export const TICKET_PHOTO_DESCRIPTION =
  'When an employee enters a Ticket Out at or above the minimum amount, the system will require them to take a photo before saving.';
export const ENABLE_VIP_MATCH = 'Enable VIP Match';
export const VIP_MATCH_DESCRIPTION =
  "When a pending customer's points are at or above the minimum amount, the employee must take a photo before the machine can be set on the Dashboard.";
export const REQUIRE_PHONE_VERIFICATION = 'Require Phone Verification';
export const PHONE_VERIFICATION_DESCRIPTION =
  "When enabled, a customer must verify their phone with an SMS code at the tablet before they can collect points. Staff can still add and edit customers on the web without verification — the check happens at the tablet only. Turn this off for locations that don't need phone verification.";
export const ENABLE_NUVE_BOOST = 'Enable NuVe Boost';
export const NUVE_BOOST_DESCRIPTION =
  'When enabled, the NuVe Boost (SMS/MMS marketing) menu is available to permitted staff at this location. Turn this off to hide NuVe Boost here — the menu updates right after you save, no re-login needed.';

export const VIP_MATCH_POINT_PRESETS = [30, 40, 50, 100, 200];
export const DEFAULT_VIP_MATCH_POINTS = 40;

// ── Validation ───────────────────────────────────────────────────────────
// Each toggle above reveals fields that the feature cannot run without:
// an empty cooldown / max-matches crashes the match check server-side, and
// an empty VIP minimum silently disables the VIP photo requirement. So the
// revealed fields become mandatory the moment their checkbox is ticked.
export const VALIDATION_BANNER =
  'Please complete the highlighted fields before saving.';
export const REQUIRED_FIELD = 'Required while this rule is enabled';
export const MUST_BE_POSITIVE = 'Enter a whole number greater than 0';
export const MUST_BE_NON_NEGATIVE = 'Enter a whole number of 0 or more';
export const INVALID_TIME = 'Use 24-hour HH:MM format, e.g. 05:00';
export const INVALID_TIME_LIST =
  'Use comma-separated 24-hour times, e.g. 05:00,17:00';

// Which revealed fields each checkbox owns — used to clear their errors
// when the checkbox is switched back off.
export const TOGGLE_FIELDS = {
  enableMatchRule: [
    'ruleName',
    'timeLimit',
    'maxMatchesPerDay',
    'resetTimes',
    'maxCountResetTime',
  ],
  ticketPhotoEnabled: ['ticketPhotoThreshold'],
  vipMatchEnabled: ['vipMatchPoints'],
};

// ── Camera Settings ──────────────────────────────────────────────────────
export const CAMERA_SETTINGS = 'Camera Settings';
export const POINT_WATCHING_CAMERA = 'Point Watching Camera';
export const POINT_WATCHING_CAMERA_HINT =
  'Takes the photo automatically when a customer gets a match.';
export const GENERAL_CAMERA = 'Customer / Raffle / Other Photos Camera';
export const GENERAL_CAMERA_HINT =
  'Opens when an employee takes a photo on the customer form, raffle, bonus, ticket out and other screens.';
export const DEFAULT_CAMERA_OPTION = "Default (browser's camera)";
export const CAMERA_NOT_ON_THIS_COMPUTER =
  'The saved camera is not connected to this computer. Other computers keep using it; pick another to change it.';
export const SAME_CAMERA_WARNING =
  'Both roles use the same camera — that works, but there is nothing to split.';
export const BACK = 'Back';
